export default __webpack_public_path__ + "static/thumb-landscape-51e43bafea89be9aca7a4e598aca5a37.jpg";